// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "f3a937148f0bba8676a0e1ec18514f90" + ".js";
};